<template>
  <div class="auth-page">
    <div class="container-fluid p-0">
      <div class="row g-0 align-items-center justify-content-center">
        <div class="col-xxl-6 col-lg-6 col-md-6">
          <div class="row justify-content-center g-0">
            <div class="col-xl-9">
              <div class="p-4">
                <div class="card mb-0">
                  <div class="card-body">
                    <div class="auth-full-page-content rounded d-flex p-3 my-2">
                      <div class="w-100">
                        <div class="d-flex flex-column h-100">
                          <div class="mb-4 mb-md-5">
                            <router-link to="/" class="d-block auth-logo">
                              <img :src="logo" alt="" height="22" class="auth-logo-dark me-start" />
                              <img :src="logo" alt="" height="22" class="auth-logo-light me-start" />
                            </router-link>
                          </div>
                          <div class="auth-content my-auto">
                            <div class="text-center">
                              <h5 class="mb-0">{{ $t('Welcome Back') }} !</h5>
                              <p class="text-muted mt-2">
                                {{ `${$t('Informe o token para continuar no')} ${domain}.` }}
                              </p>
                            </div>
                            <form autocomplete="off" class="mt-4 pt-2" @submit.stop.prevent="onLogin()">
                              <div class="form-floating form-floating-custom mb-4">
                                <input
                                  type="text"
                                  class="form-control"
                                  id="input-username"
                                  :placeholder="$t('Digite o token')"
                                  v-model="token"
                                />
                                <label for="input-username">Token</label>
                                <div class="form-floating-icon">
                                  <eva-icon name="lock-outline"></eva-icon>
                                </div>
                              </div>
                              <div class="mb-3">
                                <button class="btn btn-primary w-100 waves-effect waves-light" type="submit">
                                  Log In
                                </button>
                                <!-- <div class="text-center mt-2">
                                  <a class="w-100 pt-4 waves-effect waves-light cursor-pointer" href="/login">
                                    Log In as user
                                  </a>
                                </div> -->
                              </div>
                            </form>
                          </div>
                          <div class="mt-4 text-center">
                            <p class="mb-0">© {{ `${new Date().getFullYear()} ${domain}.` }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end auth full page content -->
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </div>
    <!-- end container fluid -->
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapActions } from 'vuex';
import api from '../../../services/data.services';
import auth from '../../../auth';
import { useToast } from 'vue-toastification';
import themes from '@/themes.config';
export default defineComponent({
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      domain: null,
      token: null,
      date: new Date()
    };
  },
  created() {
    this.domain = window.location.hostname;
  },
  methods: {
    ...mapActions(['setReportMovimento']),
    onLogin() {
      if (this.token) {
        api
          .search('report', {
            token: this.token,
            month: this.date.getMonth() + 1,
            year: this.date.getFullYear()
          })
          .then((res) => {
            this.toast.success('Usuário Autenticado!');
            const report = JSON.parse(JSON.stringify(res));
            auth.login(this.token);
            this.setReportMovimento(report);
            this.$router.push({ name: 'reportAffiliateDetail' });
          })
          .catch((err) => {
            this.toast.error(`Erro ao Autenticar: ${err}`);
          });
      }
    }
  },
  computed: {
    logo() {
      return themes[window.location.origin]?.logoLight || require('@/themes/default-logo-dark.png');
    }
  }
});
</script>
